// SSR stub — empty module for deps not needed server-side
export default {}
